import { createGlobalStore } from 'hox';
import { useState } from 'react';

import { Permission, PermissionNameEnum } from '@Types/permissions';
import common from '../utils/common';

function usePermission() {
  const [permissions, setPermissions] = useState<Permission | undefined>(
    undefined
  );

  const [managementScopeIds, setManagementScopeIds] = useState<
    string[] | 'all'
  >([]);

  const widthEditablePermission = (permissionName: PermissionNameEnum) => {
    return common.withEditPermission(permissionName, permissions);
  };

  const widthReadablePermission = (permissionName: PermissionNameEnum) => {
    return common.withReadPermission(permissionName, permissions);
  };
  return {
    permissions,
    setPermissions,
    widthEditablePermission,
    widthReadablePermission,
    managementScopeIds,
    setManagementScopeIds,
  };
}
export const [usePermissionStore] = createGlobalStore(usePermission);
